import { css } from '@emotion/css'
import { colors, shorthandHelper, spacing } from '@offerzen/pinata-shame'

const styles = {
  dinoFooter: css({
    width: '100%',
    marginTop: 'auto',
  }),

  footerNavigation: css({
    listStyle: 'none',
    display: 'flex',
    gap: spacing.large,
    margin: 0,
    borderTop: `1px solid ${colors.geyser}`,
    padding: shorthandHelper([spacing.extraLarge, 0]),
    justifyContent: 'center',

    a: {
      color: colors.jumbo,
      textDecoration: 'none',

      '&:hover': {
        color: colors.cornflowerBlue,
      },
    },
  }),

  container: css({
    overflow: 'hidden',
  }),
}

export default styles
